import React from "react";
import { useSelector } from "react-redux";
import { LanguageConstants } from "../constants/LanguageConstants";
import { isProfileBusinessAccount } from "../utils/profileAccountType";
import "./Shippingdetails.scss";

function displayShippingValue(value: unknown): string {
  const text = value == null ? "" : String(value).trim();
  return text || "—";
}

function getShippingMethodName(data: Record<string, any> | null | undefined): string {
  return (
    data?.quotation_detail?.shipping_Trans_detail?.name ??
    data?.shipping_Trans_detail?.name ??
    ""
  );
}

function getSpecialInstructions(data: Record<string, any> | null | undefined): string {
  return String(
    data?.address_detail?.instructions ??
      data?.quotation_detail?.address_detail?.instructions ??
      "",
  ).trim();
}

type ShippingDetailsProps = {
  setShow: (show: boolean) => void;
  data?: Record<string, any> | null;
  isBusiness?: boolean;
};

function Shippingdetails(props: ShippingDetailsProps) {
  const profileState = useSelector((state: any) => state?.ProfileState);
  const isBusiness =
    props.isBusiness ?? isProfileBusinessAccount(profileState);
  const data = props.data ?? {};

  const closeModal = () => props?.setShow(false);

  const modalTitle = isBusiness
    ? LanguageConstants?.ORDER_SHIPPING_MODAL_TITLE
    : LanguageConstants?.SHPPING_DEATILS;

  return (
    <div
      className="modal fade com-modal short-modal checkout-modal shipping-details-modal show"
      id="checkoutModal"
      aria-labelledby="checkoutModalLabel"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="checkoutModalLabel">
              {modalTitle}
            </h5>
            <button
              onClick={closeModal}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="icon-close-square" />
            </button>
          </div>
          <div className="modal-body pb-0 text-start">
            {isBusiness ? (
              <div className="shipping-details-modal__rows">
                <div className="shipping-details-modal__row">
                  <span className="shipping-details-modal__label">
                    {LanguageConstants?.ORDER_SHIPPING_COMPANY_LABEL}
                  </span>
                  <span className="shipping-details-modal__value">
                    {displayShippingValue(data?.shipping_company)}
                  </span>
                </div>
                <div className="shipping-details-modal__row">
                  <span className="shipping-details-modal__label">
                    {LanguageConstants?.MANUAL_QUOTE_SHIPPING_METHOD_SECTION}
                  </span>
                  <span className="shipping-details-modal__value">
                    {displayShippingValue(getShippingMethodName(data))}
                  </span>
                </div>
                <div className="shipping-details-modal__row">
                  <span className="shipping-details-modal__label">
                    {LanguageConstants?.ORDER_TRACKING_NUMBER_HASH}
                  </span>
                  <span className="shipping-details-modal__value">
                    {displayShippingValue(data?.tracking_number)}
                  </span>
                </div>
                <div className="shipping-details-modal__row">
                  <span className="shipping-details-modal__label">
                    {LanguageConstants?.ORDER_SPECIAL_INSTRUCTIONS}
                  </span>
                  <span className="shipping-details-modal__value">
                    {displayShippingValue(getSpecialInstructions(data))}
                  </span>
                </div>
              </div>
            ) : (
              <div className="id-mob">
                <div className="">
                  <span className="id-mob-label">
                    {LanguageConstants?.TRAKING_URL} :
                  </span>{" "}
                  {data?.tracking_url ? (
                    <a
                      href={data.tracking_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {data.tracking_url}
                    </a>
                  ) : (
                    "No URL available"
                  )}
                </div>
                {data?.tracking_number ? (
                  <div className="">
                    <span className="id-mob-label">
                      {LanguageConstants?.TRAKING_NUMBER} :
                    </span>{" "}
                    {data.tracking_number}
                  </div>
                ) : null}
                <div className="">
                  <span className="id-mob-label">
                    {LanguageConstants?.SHIPPINSCompany} :
                  </span>{" "}
                  {data?.shipping_company}
                </div>
                {data?.waybill_number ? (
                  <div className="">
                    <span className="id-mob-label">
                      {LanguageConstants?.WAYBILLNUMBER} :
                    </span>{" "}
                    {data.waybill_number}
                  </div>
                ) : null}
                {data?.awb_number ? (
                  <div className="">
                    <span className="id-mob-label">
                      {LanguageConstants?.AWB_NUMBER} :
                    </span>{" "}
                    {data.awb_number}
                  </div>
                ) : null}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Shippingdetails;
